import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { FormFieldSwitch } from 'src/common/FormField/FormFieldSwitch';

import { serviceDetailsNameRoot } from './ServiceDetailsFormBody';

export default function DoNotMultiloadField() {
  const fieldName = `${serviceDetailsNameRoot}.should_avoid_multiload`;
  return (
    <FormFieldController name={fieldName}>
      {({ field, fieldState }) => (
        <FormFieldSwitch
          label="Avoid multiloading?"
          error={fieldState.error?.message?.toString()}
          inputProps={{
            id: fieldName,
            ...field,
          }}
        />
      )}
    </FormFieldController>
  );
}
